import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/core/user/user.service';

@Component({
  selector: 'app-auth-event',
  templateUrl: './auth-event.component.html',
  styleUrls: ['./auth-event.component.scss'],
})
export class AuthEventComponent implements OnInit {
  accessTokenRes = this.activatedRoute.snapshot.data.accessTokenRes;

  constructor(
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    private router: Router
  ) {}

  ngOnInit() {
    this.userService.setToken(this.accessTokenRes.token);
    this.router.navigate(['/events/edit', this.accessTokenRes.id]);
  }
}
